import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles/tw.merge";

import { InputGroup } from "@/components/Form/Base/inputGroup.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type SwitchTabComponentProps = {
    tab: "list" | "map";
    openList: () => void;
    openMap: () => void;
};

export const SwitchTabComponent = ({
    tab,
    openList,
    openMap
}: SwitchTabComponentProps) => {
    const { t } = useGranite();

    return (
        <InputGroup
            role="group"
            className={cn("tw:w-fit tw:bg-background tw:rounded-sm")}
        >
            <Button
                type={"button"}
                color={tab === "list" ? "gray" : "transparent"}
                onClick={openList}
                aria-label={t("accessibility.searchStore.listTabButton")}
            >
                <i className="las la-list-ul la-lg"></i>
            </Button>
            <Button
                type={"button"}
                color={tab === "map" ? "gray" : "transparent"}
                onClick={openMap}
                aria-label={t("accessibility.searchStore.mapTabButton")}
            >
                <i className="las la-map-marked-alt la-lg"></i>
            </Button>
        </InputGroup>
    );
};
